import { render, staticRenderFns } from "./RowRate.vue?vue&type=template&id=2d463d7a&"
import script from "./RowRate.vue?vue&type=script&lang=js&"
export * from "./RowRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports